<template lang="pug" >
div.kpidataCoupon
  button(v-for="(kpi, index) in listKpis"
    :value="kpi"
    :key="index"
    @click="selectKpi(kpi.type)" :class="selected === kpi.type ? 'activeC' : 'kpi-cardsC'")
    kpi-card(:ammount='kpi.ammount' :title='kpi.title' :color='kpi.color' :percentage='kpi.percentage')
</template>

<script>
import KpiCard from '@/components/loyalty/Coupons/KpiCard'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'KpiCardsClients',
  props: ['datagraf', 'tipCons', 'fechaHasta', 'appProgram'],
  components: { 'kpi-card': KpiCard },
  data () {
    return {
      listKpis: [
        {
          ammount: ('0'),
          title: this.$t('loyalty.analytics.allClients'),
          percentage: 0,
          type: 'T',
          color: null
        },
        {
          ammount: ('0'),
          title: this.$t('loyalty.analytics.men'),
          percentage: 0,
          type: 'V',
          color: '#87BEE6'
        },
        {
          ammount: ('0'),
          title: this.$t('loyalty.analytics.noinfo'),
          percentage: 0,
          type: 'N',
          color: '#1A3B47'
        },
        {
          ammount: ('0'),
          title: this.$t('loyalty.analytics.women'),
          percentage: 0,
          type: 'M',
          color: '#7874B4'
        }
      ],
      selected: null
    }
  },
  computed: {
    ...mapGetters({
      getLang: 'getLang',
      getFechaHasta: 'getFechaHasta'
    })
  },
  async mounted () {
    this.getAmountsAndPercentages()
  },
  methods: {
    ...mapActions(['getCOTCG']),
    selectKpi (object, callService) {
      this.selected = object
      // console.log(`change to '${object}'`)
      this.$emit('type-cons', { tipCons: object, refresh: callService })
    },
    async getAmountsAndPercentages () {
      this.getCOTCG().then(response => {
        // console.log('getCLTCG response', response)
        this.listKpis[0].ammount = String(response.registros.totalclientes)
        this.listKpis[1].ammount = String(response.registros.totalhombres)
        this.listKpis[2].ammount = String(response.registros.totalnoinfo)
        this.listKpis[3].ammount = String(response.registros.totalmujeres)
        if (response.registros.totalclientes !== 0) {
          this.listKpis[1].percentage = parseFloat((response.registros.totalhombres / response.registros.totalclientes * 100).toFixed(2))
          this.listKpis[2].percentage = parseFloat((response.registros.totalnoinfo / response.registros.totalclientes * 100).toFixed(2))
          this.listKpis[3].percentage = parseFloat((response.registros.totalmujeres / response.registros.totalclientes * 100).toFixed(2))
        } else {
          this.listKpis[1].percentage = parseFloat('0')
          this.listKpis[2].percentage = parseFloat('0')
          this.listKpis[3].percentage = parseFloat('0')
        }
        this.selectKpi(this.tipCons ? this.tipCons : this.listKpis[0].type, true)
      }).catch(err => {
        console.log('getCLTCG response', err)
      })
    }
  },
  watch: {
    async getLang () {
      this.listKpis[0].title = this.$t('loyalty.analytics.allClients')
      this.listKpis[1].title = this.$t('loyalty.analytics.men')
      this.listKpis[2].title = this.$t('loyalty.analytics.noinfo')
      this.listKpis[3].title = this.$t('loyalty.analytics.women')
    },
    async getFechaHasta (newData, oldData) {
      if (newData) {
        // console.log(`KPI getFechaHasta ${newData} ${oldData}`)
        // console.log(`KPI tipCons ${this.tipCons} fechaHasta ${this.fechaHasta}`)
        this.getAmountsAndPercentages()
      }
    },
    async appProgram (newData, oldData) {
      if (newData) {
        // console.log(`KPI getAppProgram ${newData} ${oldData}`)
        this.getAmountsAndPercentages()
      }
    }
  }
}
</script>

<style lang="scss">
</style>
